import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import I18n from "i18next";
import OtpInput from "react-otp-input";
import MzButton from "@markaaz/ui/MzButton";
import MzAlert from "@markaaz/ui/MzAlert";
import SignUpFooter from "./Footer";
import AuthFooterLink from "commonComponents/AuthFooterLink";

const sx = {
  root: {
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    h5: {
      color: "darkBlue.c100"
    }
  },

  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    flex: 1
  },

  otp: {
    margin: "60px",
    "> div": {
      gap: "10px"
    },

    input: {
      width: "36px !important",
      height: "50px ",
      color: "blue.c100",
      border: "none",
      outline: "none",
      fontSize: "18px ",
      borderRadius: "5px"
    }
  },

  button: {
    marginBottom: "15px"
  }
};

export default function VerifyOtp({ loading, showResend = true, showNotification, onAlertClose, onSubmit, onResend }) {
  const [otp, setOtp] = useState("");
  const location = useLocation();
  const [userNotConfirmed, setUserNotConfirmed] = useState({ type: "", message: "" });

  useEffect(() => {
    if (location.search.includes("verifyOtp")) {
      setUserNotConfirmed({ type: "error", message: "User is not confirmed" });
    }
  }, [location]);

  const handleCloseAlert = () => {
    setUserNotConfirmed({ message: "", type: "" });
    if (onAlertClose) onAlertClose();
  };

  const alertMessage = showNotification.message ? showNotification.message : userNotConfirmed.message;
  const alertSeverity = showNotification.type ? showNotification.type : userNotConfirmed.type;

  return (
    <Box sx={sx.root}>
      <Box sx={sx.content}>
        <Typography variant="h5">Enter the verification code sent to your email</Typography>
        <Box sx={sx.otp}>
          <OtpInput
            value={otp}
            onChange={setOtp}
            numInputs={6}
            inputType="tel"
            renderInput={(props) => <input {...props} />}
          />
        </Box>
        <MzButton
          sx={sx.button}
          variant="contained"
          color="primary"
          size="large"
          loading={loading}
          onClick={() => {
            onSubmit(otp);
          }}
        >
          Continue
        </MzButton>
        {showResend && <MzButton onClick={onResend}>{I18n.t("authPages.resendCode")}</MzButton>}
      </Box>
      <Box>
        {alertMessage && (
          <MzAlert
            sx={{ alignItems: "center", marginBottom: "30px", width: "394px" }}
            severity={alertSeverity === "success" ? "success" : "error"}
            onClose={handleCloseAlert}
          >
            {alertMessage}
          </MzAlert>
        )}
      </Box>

      <SignUpFooter />
      <AuthFooterLink />
    </Box>
  );
}
